import { ref } from 'vue';

const enabled = ref(false);

interface UseExitHandler {
  enable(): void;
  disable(): void;
}
export const useExitHandler = (): UseExitHandler => {
  const handler = (e: Event): void => {
    if (!enabled.value) return;

    const event = e;
    event.preventDefault();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    event.returnValue = ''; // Chrome workaround :-/
  };

  const enable = (): void => {
    enabled.value = true;
    window.addEventListener('beforeunload', handler);
  };

  const disable = (): void => {
    enabled.value = false;
    window.removeEventListener('beforeunload', handler);
  };

  return {
    enable,
    disable,
  };
};
